import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router} from '@angular/router';
import { MitterService } from '../../../services/mitter.service';
import * as moment from 'moment';
import { CommonService } from '../../../services/common.service';
@Component({
  selector: 'app-channel-list',
  templateUrl: './channel-list.component.html',
  styleUrls: ['./channel-list.component.css']
})
export class ChannelListComponent implements OnInit {
  mitter: any;
  videochatflag = 0
  liveChannels: any[];
  selectedChannels: any[];
  activeChannel: any;
  userRole: string;
  currentTab = 'Started';
  activeLiveChannel: object;
  tabChannels = [];
  p = 1;
  channelIdFromRoute: string;
  usernamearray: any = {};
  userimgarray: any = {};
  timer: any;
  counter = 0;
  constructor(private mitterService: MitterService,private commonService: CommonService,
      private route: ActivatedRoute, private router: Router) {
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.channelIdFromRoute = params['chatid'];
    });
    
      this.mitterService.synchUser(false)
      .then(() => this.mitter = this.mitterService.getMitter())
      .then(() => this.synchChannels(true))
      .then(() => {
        this.mitter.onChannelTimelineEventReceived((channelId, data) => {
          this.counter = 3;
          this.timer = setInterval(() => this.delay(), 1000);
        })
      });

    this.userRole = this.mitterService.getUserRole();
   // setInterval(this.synchChannels.bind(this), 5000);

    window.onfocus = () => {
      this.synchChannels.bind(this, true);
    }
  }
delay() {
  if(this.counter != 0){
  this.counter = this.counter - 1;
  if(this.counter == 0) {
    this.synchChannels(true);
     this.intervalClear();
  }
}
}
intervalClear(){
clearInterval(this.timer);
}
 
  synchChannels(shouldSynchMessage) {
    if (!this.mitterService) return;

    this.mitterService.getAllLiveChannels()
      .then((data: any[]) => {
        data.forEach(liveChannel => {
          this.synchLastMessage(liveChannel);
          shouldSynchMessage && this.synchMessages(liveChannel.mitterChannelId);
        });
        this.liveChannels = data;
        if (this.userRole === 'DOCTOR') {
          for (let i = 0; i < this.liveChannels.length; i++) {
            this.getUserDataOfChannel(this.liveChannels[i].customerExternalId);
          }
        }else  if (this.userRole === 'PATIENT') {
          for (let i = 0; i < this.liveChannels.length; i++) {
            this. getUserDataOfChannel(this.liveChannels[i].serviceProviderExternalId);
          }
        }
        this.showTab(this.currentTab);
        this.activeChannel = this.channelIdFromRoute;
        this.activeLiveChannel = this.liveChannels.find(liveChannel => liveChannel.mitterChannelId === this.activeChannel)
      });
  }

  synchMessages(channelId) {
    this.mitterService.mitter && this.mitterService.mitter.getAllMessagesForChannel(channelId);
  }
  getUserDataOfChannel(customerExternalId) {
    this.commonService.getAppointmentmentUserDetail(customerExternalId)
    .subscribe(
        (x) => {
            if (x) {
              this.userimgarray['id' + customerExternalId] = x[0].image;
              this.usernamearray['id' + customerExternalId] = x[0].name;
            }
        }
    );
}

  showTab(tab: string) {
     this.currentTab = tab;
     this.tabChannels = this.liveChannels && this.liveChannels.filter(channel => channel.channelStatus == tab)
  }

  formatDate(timestamp) {
    return moment(timestamp).format("hh:mma");
  }
  formatDate1(timestamp) {
    return moment(timestamp).format('MM/DD/YYYY');
  }

  synchLastMessage(liveChannel) {
    if (!this.mitterService.mitter) return;

    var messages = this.mitterService.mitter.getMessagesForChannel(liveChannel.mitterChannelId);
    if (messages && messages.length > 0) {
      liveChannel.lastMessage = messages[messages.length - 1];
    }
  }

  openLiveChannel(liveChannel) {
    if (liveChannel.channelStatus == "Scheduled") {
      alert("This appointment has not yet begun! \n Cannot open chat");
    } else {
      this.activeChannel = liveChannel.mitterChannelId;
      this.activeLiveChannel = liveChannel;
      this.router.navigate(["/chats/", this.activeChannel]);
    }
  }

  getChannelClasses(liveChannel) {
    return {
      "mt-live-channel": true,
      [liveChannel.channelStatus]: true,
      selected: this.activeLiveChannel &&
        this.activeLiveChannel['mitterChannelId'] === liveChannel.mitterChannelId
    };
  }

  getTabClasses(tab) {
    return {
      'mt-live-channel-list-tab': true,
      selected: this.currentTab === tab
    };
  }
}
